import { AppError } from "infrastructure/error";
import { ILocalizable } from "infrastructure/localization";

export enum HttpStatusCodes {
  OK = 200,
  BadRequest = 400,
  ServerError = 500,
  Unauthorized = 401
}

export class HttpError extends AppError {
  public statusCode: HttpStatusCodes;
  public data: any;

  public constructor(statusCode: HttpStatusCodes, data?: any, message?: ILocalizable | string, error?: Error) {
    super(message != null ? message : error != null ? error.message : "", error);

    this.statusCode = statusCode;
    this.data = data;
  }
}
